// extracted by mini-css-extract-plugin
module.exports = {"navbarMenu":"Navbar_navbarMenu__3IJqb","intergrationMenuBar":"Navbar_intergrationMenuBar__ZBelT","integrateIcon":"Navbar_integrateIcon__MHU_v"};